import React from "react";
import {
  Link,
} from "react-router-dom";

import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const Pricing = () => {
  //const history = useHistory();

  return (
    <>
      <main className="dark:bg-gray-800 bg-white  h-screen">
      <header className="h-24 sm:h-32 flex items-center z-30 w-full">
          <div className="container mx-auto px-6 flex items-center justify-center lg:justify-between">
            <div className="uppercase text-gray-800 dark:text-white font-black text-3xl">
              Autolini
            </div>
            <div className="items-center hidden lg:flex">
              <nav className="text-gray-800 dark:text-white uppercase text-lg flex items-center ">
                <Link to='/' className="py-2 px-6 flex">
                  Accueil
                </Link>
                <Link to='/pricing' className="py-2 px-6 flex">
                  Tarifs
                </Link>
                <Link to='/app' className="py-2 px-6 flex">
                  Se connecter
                </Link>
              </nav>
            </div>
        </div>
      </header>
      <div className="items-center justify-center flex lg:hidden">
        <nav className="text-gray-800 dark:text-white uppercase text-lg flex items-center flex-col ">
          <Link to='/' className="py-2 px-6 flex">
            Accueil
          </Link>
          <Link to='/pricing' className="py-2 px-6 flex">
            Tarifs
          </Link>
          <Link to='/app' className="py-2 px-6 flex">
            Se connecter
          </Link>
        </nav>
      </div>
      <hr/>
      <div className="bg-white dark:bg-gray-800 flex relative z-20 items-center">
        <div className="container mx-auto px-6 py-8">
          <div>
            <h1 className="font-light w-full uppercase text-center text-2xl sm:text-3xl dark:text-white text-gray-800">
              Une offre adaptée à vos besoins
            </h1>
            <h2 className="font-light max-w-2xl mx-auto w-full text-xl dark:text-white text-gray-500 text-center py-8">
              Essai gratuit de 15 jours. Aucune carte requise.
            </h2>
          </div>
          <div className="flex justify-center items-center flex-col lg:flex-row">
            <div className="shadow-lg rounded-2xl w-64 bg-white dark:bg-gray-800 p-5 mr-0 lg:mr-5">
              <p className="text-gray-800 dark:text-gray-50 text-xl font-medium mb-4">
                Basic
              </p>
              <p className="text-gray-900 dark:text-white text-3xl font-bold">
                9,99€
                <span className="text-gray-300 text-sm ml-1">
                  / mois
                </span>
              </p>
              <p className="text-gray-600 dark:text-gray-100  text-xs mt-4 text-center">
                Engagement minimum de 12 mois
              </p>
              <ul className="text-sm text-gray-600 dark:text-gray-100 w-full mt-6 mb-6">
                <li className="mb-3 flex items-center">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  1 Utilisateur
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Dossiers illimités
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Archives de 6 mois
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Gestion des avis clients
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  SMS semi-automatisé
                </li>
                <li className="mb-3 flex items-center ">
                  <FaTimesCircle color="rgb(220 38 38)" className='mr-1 text-xl' />
                  Gestion des rendez-vous
                </li>
                <li className="mb-3 flex items-center ">
                  <FaTimesCircle color="rgb(220 38 38)" className='mr-1 text-xl' />
                  Personnalisation visuelle
                </li>
                <li className="mb-3 flex items-center ">
                  <FaTimesCircle color="rgb(220 38 38)" className='mr-1 text-xl' />
                  Nom de domaine personnalisé
                </li>
              </ul>
              <div className="text-center">
                <a href={`mailto:${process.env.REACT_APP_MAIL}?subject=[Autolini] Formule Basic&body=Renseignez ici vos coordonnées afin que nous puissions vous contacter`}  className="py-2 px-4 bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
                  Je me lance
                </a>
              </div>
            </div>
            <div className="shadow-xl rounded-2xl w-64 bg-white dark:bg-gray-800 p-5 mr-0 lg:mr-5  ml-0 lg:ml-5 mt-5 lg:mt-0">
              <p className="text-gray-800 dark:text-gray-50 text-xl font-medium mb-4">
                Smart
              </p>
              <p className="text-gray-900 dark:text-white text-3xl font-bold">
                29,99€
                <span className="text-gray-300 text-sm ml-1">
                  / mois
                </span>
              </p>
              <p className="text-gray-600 dark:text-gray-100  text-xs mt-4 text-center">
                Engagement minimum de 6 mois
              </p>
              <ul className="text-sm text-gray-600 dark:text-gray-100 w-full mt-6 mb-6">
                <li className="mb-3 flex items-center">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  5 Utilisateurs
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Dossiers illimités
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Archives de 1 an
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Gestion des avis clients
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  SMS semi-automatisé
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Gestion des rendez-vous
                </li>
                <li className="mb-3 flex items-center ">
                  <FaTimesCircle color="rgb(220 38 38)" className='mr-1 text-xl' />
                  Personnalisation visuelle
                </li>
                <li className="mb-3 flex items-center ">
                  <FaTimesCircle color="rgb(220 38 38)" className='mr-1 text-xl' />
                  Nom de domaine personnalisé
                </li>
              </ul>
              <div className="text-center">
                <a href={`mailto:${process.env.REACT_APP_MAIL}?subject=[Autolini] Formule Smart&body=Renseignez ici vos coordonnées afin que nous puissions vous contacter`}  className="py-2 px-4 bg-green-600 hover:bg-green-700 focus:ring-green-500 focus:ring-offset-green-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
                  Je me lance
                </a>
              </div>
            </div>
            <div className="shadow-lg rounded-2xl w-64 bg-white dark:bg-gray-800 p-5 lg:ml-5 mt-5 lg:mt-0">
              <p className="text-gray-800 dark:text-gray-50 text-xl font-medium mb-4">
                Premium
              </p>
              <p className="text-gray-900 dark:text-white text-3xl font-bold">
                89,99€
                <span className="text-gray-300 text-sm ml-1">
                  / mois
                </span>
              </p>
              <p className="text-gray-600 dark:text-gray-100  text-xs mt-4 text-center">
                Sans engagement
              </p>
              <ul className="text-sm text-gray-600 dark:text-gray-100 w-full mt-6 mb-6">
                <li className="mb-3 flex items-center">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  10 Utilisateurs
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Dossiers illimités
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Archives de 1 an
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Gestion des avis clients
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  SMS semi-automatisé
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Gestion des rendez-vous
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Personnalisation visuelle
                </li>
                <li className="mb-3 flex items-center ">
                  <FaCheckCircle color="rgb(22 163 74)" className='mr-1 text-xl' />
                  Nom de domaine personnalisé
                </li>
              </ul>
              <div className="text-center">
                <a href={`mailto:${process.env.REACT_APP_MAIL}?subject=[Autolini] Formule Premimum&body=Renseignez ici vos coordonnées afin que nous puissions vous contacter`}  className="py-2 px-4 bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
                  Je me lance
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      </main>
      <footer className="bg-white dark:bg-gray-800 w-full py-8">
          <div className="max-w-screen-xl mx-auto px-4">
              <ul className="mx-auto text-sm font-light flex flex-wrap justify-between">
                  <li className="my-2">
                    Copyright © Autolini 2021. Tous droits réservés.
                  </li>
                  <li className="my-2">
                      <a className="text-gray-400 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white transition-colors duration-200" href="/politique_de_Confidentialite.pdf">
                        Politique de confidentialité
                      </a>
                  </li>
                  <li className="my-2">
                      <a className="text-gray-400 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white transition-colors duration-200" href="/cgv.pdf">
                          Mentions légales et Conditions Générales d'Utilisation et de Vente
                      </a>
                  </li>
              </ul>
          </div>
      </footer>
    </>
  );
}

export default Pricing
